import { UserMessage } from '@/models/user.model';
import { BaseService, Status, DataResponse } from './base.service';

class MessageService extends BaseService {
  private url: string = '/api/user-message';

  constructor() {
    super();
  }

  public async getUserMessages(
    id: number,
  ): Promise<DataResponse<UserMessage[]>> {
    const res = await this.$http.get<UserMessage[]>(
      `${this.url}/by-user/${id}`,
    );
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }
}

export default new MessageService();
